import { v4 } from 'uuid';
import { isConditionalFeature, isDevFlag, locales } from '@americanexpress/conditional-features';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import CLIENT_ID_ONLINE from '../constants/rootConstants';
import { getHomeApiUrl, getTravelerApiUrl } from '../selectors/getBaseUrlSelectors';

const usTravelApiV2Rule = {
  devFlag: 'usTravelApiV2',
  locales: [locales.EN_US],
};

const isIntlV2 = (state) => isDevFlag('travelerApiV2') && getActiveLocaleSelector(state) !== locales.EN_US;
const isUSV2 = (state) => isConditionalFeature(usTravelApiV2Rule, state);

export default {
  fetch: (id, action, state) => {
    if (isIntlV2(state) || isUSV2(state)) {
      const locale = getActiveLocaleSelector(state);

      return {
        url: `${getTravelerApiUrl(state)}/travel/v2/travel_services/traveler/details?locale=${locale}&x-tls-encryption=hiped`,
        opts: {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            correlation_id: v4(),
          },
        },
      };
    }

    return {
      url: `${getHomeApiUrl(state)}/travel/home/v1/traveler`,
      opts: {
        method: 'GET',
        credentials: 'include',
        headers: {
          client_id: CLIENT_ID_ONLINE,
          correlationId: v4(),
        },
      },
    };
  },
};
